module.exports = __webpack_public_path__ + "static/media/17-old.a3c77632.ogg";